import { cva, VariantProps } from 'class-variance-authority'

export type AppointmentStatusPillStyling = VariantProps<typeof appointmentStatusPillStyling>

export const appointmentStatusPillStyling = cva('flex items-center gap-stack-tight bg-surface rounded-pill border border-border w-fit', {
  variants: {
    size: {
      sm: 'px-stack-tight py-stack-dense',
      md: 'px-stack py-stack-dense',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
